<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>Item Master {{ subTitle }}</h1>
        <div class="page__title_buttons row-start-center">
          @if (canEdit()) {
            @if (standardViewMode) {
              <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (onClick)="openItemModal()" />
            }
          }
        </div>
      </div>
    </div>

    <section>
      <div class="row-between-center mb-[2rem] gap-4">
        @if (!standardViewMode) {
          <div class="row-sm-start-center">
            <p-button
              icon="pi pi-filter"
              [label]="'Filter' | translateWF: 'Filter'"
              variant="outlined"
              severity="contrast"
              (onClick)="showProposalFilter.set(!showProposalFilter())"
            />
            @if (showProposalFilter()) {
              <input
                pInputText
                type="text"
                placeholder="Filter by Base PD Code..."
                [ngModel]="proposalItemCodeFilter()"
                (ngModelChange)="proposalItemCodeFilter.set($event)"
                class="w-48"
              />
            }
          </div>
        }

        <p-selectButton [(ngModel)]="displayMode" [options]="viewModeOptions" optionLabel="label" optionValue="value" class="inline-flex ml-auto">
          <ng-template let-option pTemplate="item">
            @if (option.value === 'item-master') {
              <i class="text-lg pi pi-database"></i>
            } @else {
              <i class="text-lg pi pi-send"></i>
            }
          </ng-template>
        </p-selectButton>
      </div>

      <div class="cs-page-list-grid">
        @if (standardViewMode) {
          @if (showFilters() && filterConfig()) {
            <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
          }

          <p-panel header="Item Master">
            <ng-template pTemplate="icons">
              <p-button
                [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                (click)="showFilters.set(!showFilters())"
                variant="outlined"
                size="small"
              />
            </ng-template>
            <p-card data-variant="compact">
              <p-table dataKey="id" [value]="allItems()" [lazy]="true" (onSort)="onSort($event)" selectionMode="single">
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                      {{ 'ItemMaster_TableStatus' | translateWF: 'Status' }}
                    </th>
                    <th class="col-action"></th>
                    <th pSortableColumn="itemCode" class="col-item-code">
                      {{ 'ItemMaster_TableItemCode' | translateWF: 'Item Code' }}
                      <p-sortIcon field="itemCode" />
                    </th>
                    <th class="col-pd-code">
                      {{ 'ItemMaster_TablePdCode' | translateWF: 'PD Code' }}
                    </th>
                    <th pSortableColumn="name" class="col-name">
                      {{ 'ItemMaster_TableName' | translateWF: 'Name' }}
                      <p-sortIcon field="name" />
                    </th>
                    <th class="col-long-name">
                      {{ 'ItemMaster_TableLongName' | translateWF: 'Long Name' }}
                    </th>
                    <th class="col-description">
                      {{ 'ItemMaster_TableDescription' | translateWF: 'Description' }}
                    </th>
                    <th class="col-uom">
                      {{ 'ItemMaster_TableUnitOfMeasure' | translateWF: 'Unit of Measure' }}
                    </th>
                    <th>
                      {{ 'ItemMaster_TableCategory' | translateWF: 'Category' }}
                    </th>
                    <th>
                      {{ 'ItemMaster_TableLowestSubCategory' | translateWF: 'Lowest Subcategory' }}
                    </th>
                    <th>
                      {{ 'ItemMaster_TableInventoryType' | translateWF: 'Inventory Type' }}
                    </th>
                    <th>
                      {{ 'ItemMaster_TableClassification' | translateWF: 'Classification' }}
                    </th>
                    @if (canAssignSites()) {
                      <th>
                        {{ 'ItemMaster_TableSite' | translateWF: 'Site' }}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                  @let item = getRowData(rowData);
                  <tr>
                    <td>
                      {{ getStatusName(item.status) }}
                    </td>
                    <td class="col-action" (click)="openItemModal(item, undefined, true)">
                      <p-button severity="secondary" icon="pi pi-copy" title="Copy Item Master"></p-button>
                    </td>
                    <td class="col-item-code cursor-pointer" (click)="openItemModal(item)">
                      <a>{{ item.itemCode }}</a>
                    </td>
                    <td class="col-pd-code">
                      {{ item.baseFabricCode || item.baseGreigeCode || item.baseYarnCode }}
                    </td>
                    <td class="col-name">
                      {{ item.itemDisplayName | localized }}
                    </td>
                    <td class="col-long-name">
                      {{ item.itemLongDisplayName | localized }}
                    </td>
                    <td class="col-description">
                      {{ item.itemDescription | localized }}
                    </td>
                    <td class="col-uom">
                      {{ getUnitName(item.unitOfMeasure) }}
                    </td>
                    <td>{{ getCategoryCode(item.itemCategoryCode) }}</td>
                    <td>
                      {{ getCategoryCode(item.itemLowestSubCategoryCode) }}
                    </td>
                    <td>
                      {{ getInventoryType(item.inventoryTypeReference) }}
                    </td>
                    <td>
                      {{ item.itemClassificationCode }}
                    </td>
                    @if (canAssignSites()) {
                      <td>
                        {{ getAssignedSiteNames(item) }}
                      </td>
                    }
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="12">
                      {{ 'No_Records_Available' | translateWF: 'No records available!' }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <p-paginator
                [rows]="pageSize()"
                [totalRecords]="totalRecords()"
                [first]="(currentPage() - 1) * pageSize()"
                (onPageChange)="onPageChange($event)"
                [rowsPerPageOptions]="[15, 25, 50]"
                class="mt-4"
              />
            </p-card>
          </p-panel>
        } @else {
          <div class="span-12">
            <p-table
              dataKey="id"
              [value]="filteredItemProposals()"
              [paginator]="true"
              [rows]="25"
              [rowsPerPageOptions]="[15, 25, 50]"
              [first]="firstPaginationProposals()"
              (onPage)="onPageChangeProposals($event)"
              selectionMode="single"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    {{ 'ItemMaster_TableStatus' | translateWF: 'Status' }}
                  </th>
                  <th>
                    {{ 'ItemMaster_TableBasePdCode' | translateWF: 'Base PD Code' }}
                  </th>
                  <th>
                    {{ 'ItemMaster_TableCategory' | translateWF: 'Category' }}
                  </th>
                  <th>
                    {{ 'ItemMaster_TableDescription' | translateWF: 'Description' }}
                  </th>
                  <th>
                    {{ 'ItemMaster_TableAction' | translateWF: 'Action' }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                @let item = getProposalRowData(rowData);
                <tr>
                  <td>
                    {{ itemMasterProposalStatuses()[item.status] }}
                  </td>
                  <td>
                    {{ item.itemCode }}
                  </td>
                  <td>
                    {{ item.mongoDBCollection }}
                  </td>
                  <td>
                    {{ item.itemDescription }}
                  </td>
                  <td>
                    <p-button icon="pi pi-pencil" (click)="openItemModal(undefined, item)"></p-button>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    {{ 'No_Records_Available' | translateWF: 'No records available!' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </section>
  </div>
</main>
